import React from 'react';

export function Logo(props: React.HTMLAttributes<HTMLDivElement>) {
  return <div {...props}>Flashcard.app</div>;
}
